var map = {
	"./1.jpg": 6572,
	"./10.jpg": 2921,
	"./2.jpg": 7781,
	"./3.jpg": 1719,
	"./4.jpg": 3778,
	"./5.jpg": 7883,
	"assets/photo/reportage/painters/1.jpg": 6572,
	"assets/photo/reportage/painters/10.jpg": 2921,
	"assets/photo/reportage/painters/2.jpg": 7781,
	"assets/photo/reportage/painters/3.jpg": 1719,
	"assets/photo/reportage/painters/4.jpg": 3778,
	"assets/photo/reportage/painters/5.jpg": 7883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9916;